/**
 * File for tracking clicks
 */
import store from '@/bootstrap/services/store';

export function analyticsClickTrack () {
	const config: any = store.getters.get_analyticsConfig;

	// All elements
	const clickElements = document.querySelectorAll('.analytics-click');

	clickElements.forEach((element: Element) => {
		const status = element.getAttribute('data-analytics-listener');
		if (status == 'true') { return; }

		const handler = () => {
			element.setAttribute('data-analytics-listener', 'true');

			const name = element.getAttribute('data-analytics-name');
			const id = element.getAttribute('data-analytics-id');
			const trackingObj = { name, id };

			(config || []).forEach((obj: any) => {
				const { methods } = obj;
				if (!(methods && methods.trackClick)) { return; }
		
				methods.trackClick(trackingObj);
			});	
		}
		element.addEventListener('click', handler);
	});
}

export function analyticsClickElmTrack (track: any) {
	const config: any = store.getters.get_analyticsConfig;

	(config || []).forEach((obj: any) => {
		const { methods } = obj;
		if (!(methods && methods.trackClick)) { return; }

		methods.trackClick(track);
	});	
}
